import React, { useEffect, useState } from "react";
import { X, ShieldCheck, KeyRound, Trash2, Shield, ShieldOff, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import * as api from "../api";

function UserRow({ u, me, onChanged }) {
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);
  const isMe = u.id === me?.id;

  const run = async (fn, ok) => {
    setBusy(true);
    try {
      await fn();
      toast.success(ok);
      setPwd("");
      onChanged();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Operazione non riuscita");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-row" data-testid={`admin-row-${u.id}`}>
      <div className="admin-row-head">
        <div className="admin-user">
          <span className="admin-name">
            {u.nome || "—"} {u.role === "admin" && <span className="admin-badge">ADMIN</span>} {isMe && <span className="admin-me">(tu)</span>}
          </span>
          <span className="admin-email">{u.email}</span>
          <span className="admin-meta">{u.accounts} account di posta</span>
        </div>
        <div className="admin-actions">
          <button
            className="icon-btn"
            title={u.role === "admin" ? "Togli admin" : "Rendi admin"}
            aria-label={u.role === "admin" ? "Togli admin" : "Rendi admin"}
            disabled={busy || isMe}
            onClick={() => run(() => api.adminSetRole(u.id, u.role === "admin" ? "user" : "admin"), "Ruolo aggiornato")}
            data-testid={`admin-role-${u.id}`}
          >
            {u.role === "admin" ? <ShieldOff size={17} strokeWidth={2.3} /> : <Shield size={17} strokeWidth={2.3} />}
          </button>
          <button
            className="icon-btn del-acc-btn"
            title="Elimina utente"
            aria-label="Elimina utente"
            disabled={busy || isMe}
            onClick={() => {
              if (window.confirm(`Eliminare l'utente ${u.email} con tutti i suoi account e le email importate?`)) {
                run(() => api.adminDeleteUser(u.id), "Utente eliminato");
              }
            }}
            data-testid={`admin-delete-${u.id}`}
          >
            <Trash2 size={17} strokeWidth={2.3} />
          </button>
        </div>
      </div>
      <div className="admin-pwd">
        <KeyRound size={15} strokeWidth={2.3} />
        <input
          className="wf-input"
          type="text"
          placeholder="Nuova password"
          value={pwd}
          onChange={(e) => setPwd(e.target.value)}
          data-testid={`admin-pwd-input-${u.id}`}
        />
        <button
          className="wf-btn primary"
          disabled={busy || pwd.length < 4}
          onClick={() => run(() => api.adminSetPassword(u.id, pwd), "Password cambiata")}
          data-testid={`admin-pwd-save-${u.id}`}
        >
          Cambia
        </button>
      </div>
    </div>
  );
}

// Pannello amministratore: elenco utenti, cambio password, ruolo, eliminazione
export default function AdminModal({ open, onClose, me }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = () => {
    setLoading(true);
    api
      .adminUsers()
      .then(setUsers)
      .catch((e) => toast.error(e?.response?.data?.detail || "Elenco utenti non disponibile"))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (open) load();
  }, [open]);

  return (
    <div className={`wf-modal-backdrop ${open ? "show" : ""}`} onClick={onClose}>
      <div className="wf-modal ctx-modal admin-modal" onClick={(e) => e.stopPropagation()} data-testid="admin-modal">
        <div className="wf-modal-head">
          <span className="wf-modal-title">
            <ShieldCheck size={19} strokeWidth={2.3} /> Utenti ({users.length})
          </span>
          <div style={{ display: "flex", gap: 6 }}>
            <button className="icon-btn" onClick={load} aria-label="Aggiorna" title="Aggiorna" data-testid="admin-refresh">
              <RefreshCw size={18} strokeWidth={2.4} className={loading ? "spin" : ""} />
            </button>
            <button className="icon-btn" onClick={onClose} aria-label="Chiudi" data-testid="admin-close">
              <X size={20} strokeWidth={2.6} />
            </button>
          </div>
        </div>
        <div className="ctx-sub" style={{ margin: "0 0 10px" }}>
          Gli amministratori possono cambiare le password e cancellare gli utenti.
        </div>
        <div className="admin-list">
          {users.map((u) => (
            <UserRow key={u.id} u={u} me={me} onChanged={load} />
          ))}
          {!loading && users.length === 0 && <div className="admin-empty">Nessun utente</div>}
        </div>
      </div>
    </div>
  );
}
